import { lazy } from 'react';

const DwollaConfig = {
  settings: {
    layout: {
      // style: 'layout1',
      config: {
        navbar: {
          display: false,
        },
        toolbar: {
          display: false,
        },
        footer: {
          display: false,
        },
        mode: 'fullwidth',
      },
    },
  },
  routes: [
    {
      path: '/dwolla/:id/:invi',
      component: lazy(() => import('./DwollaApp')),
    },
  ],
};

export default DwollaConfig;
